module.exports = __webpack_public_path__ + "img/cwm-websitetiles-itwct-f01-moriyama-72dpi.b0fa3cd6.jpg";